var Base = require('_js/base'),
  ko = require('knockout');

var model = function(params) {
  this.params = params;
};

function ReportPage() {
  this.init();
}

ReportPage.prototype = new Base();

ReportPage.prototype.init = function() {
  var $reportPage = $('[data-report-page]');
  if ($reportPage.get(0) !== undefined) {
    ko.applyBindings(
      new model({ element: $reportPage.data('report-page') }),
      $reportPage.get(0)
    );
  }
};

module.exports = ReportPage;
